// Generated by purs version 0.13.0
"use strict";
var N = (function () {
    function N() {

    };
    N.value = new N();
    return N;
})();
var NE = (function () {
    function NE() {

    };
    NE.value = new NE();
    return NE;
})();
var E = (function () {
    function E() {

    };
    E.value = new E();
    return E;
})();
var SE = (function () {
    function SE() {

    };
    SE.value = new SE();
    return SE;
})();
var S = (function () {
    function S() {

    };
    S.value = new S();
    return S;
})();
var SW = (function () {
    function SW() {

    };
    SW.value = new SW();
    return SW;
})();
var W = (function () {
    function W() {

    };
    W.value = new W();
    return W;
})();
var NW = (function () {
    function NW() {

    };
    NW.value = new NW();
    return NW;
})();
var directionDelta = function (v) {
    if (v instanceof N) {
        return {
            x: 0,
            y: -1 | 0
        };
    };
    if (v instanceof NE) {
        return {
            x: 1,
            y: -1 | 0
        };
    };
    if (v instanceof E) {
        return {
            x: 1,
            y: 0
        };
    };
    if (v instanceof SE) {
        return {
            x: 1,
            y: 1
        };
    };
    if (v instanceof S) {
        return {
            x: 0,
            y: 1
        };
    };
    if (v instanceof SW) {
        return {
            x: -1 | 0,
            y: 1
        };
    };
    if (v instanceof W) {
        return {
            x: -1 | 0,
            y: 0
        };
    };
    if (v instanceof NW) {
        return {
            x: -1 | 0,
            y: -1 | 0
        };
    };
    throw new Error("Failed pattern match at Ritoppu.Model.Direction (line 21, column 18 - line 29, column 25): " + [ v.constructor.name ]);
};
module.exports = {
    N: N,
    NE: NE,
    E: E,
    SE: SE,
    S: S,
    SW: SW,
    W: W,
    NW: NW,
    directionDelta: directionDelta
};
